import React from "react";
import styles from "@/components/CustomComponents/ArticlePageCarousel/index.module.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  ThinChevronRight,
  ThinChevronLeft,
} from "@/components/CustomComponents/ArticlePageCarousel/icons";
import Image from "next/image";
import Link from "next/link";
import PropTypes from "prop-types";
import { useDeviceType } from "@/hooks/useDeviceType";
import "swiper/css";
import "swiper/css/navigation";
import { renderRichText } from "@/utils/formatters";
import { useRouter } from "next/router";

function capitalizeFirstLetter(str) {
  return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
}

const ArticlePageCarousel = props => {
  const { fields } = props;
  const { locale } = useRouter();
  const {
    images = [],
    heading = "",
    upperBorder = true,
    textPlacement = "center",
    description = "",
    background = "white",
    borderColor = "white",
    adjustDescPadding = false,
  } = fields || {};
  const { width } = useDeviceType();
  let slidesToShow = 3;
  if (width < 480) slidesToShow = 1;
  else if (width < 840) slidesToShow = 2;

  const validBackgrounds = ["white", "black"];
  const bg = validBackgrounds.includes(background) ? background : "white";
  const isWhiteBg = bg === "white";

  const colorMap = {
    Yellow: "border-[#f2a054]",
    Blue: "border-[#92d7e9]",
  };

  const normalizedBorderColor =
    borderColor && borderColor.trim() !== "" ? borderColor : null;
  const hrColorClass = isWhiteBg
    ? "border-b border-[#e8e8e8]"
    : `border-b ${
        normalizedBorderColor && colorMap[normalizedBorderColor]
          ? colorMap[normalizedBorderColor]
          : "border-white"
      }`;

  const settings = {
    infinite: true,
    slidesToShow,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 500,

    responsive: [
      {
        breakpoint: 840,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 479,
        settings: { slidesToShow: 1 },
      },
    ],
    nextArrow: <ThinChevronRight color={isWhiteBg ? "#000" : "#fff"} />,
    prevArrow: <ThinChevronLeft color={isWhiteBg ? "#000" : "#fff"} />,
  };

  const adjustDescPaddingClass = adjustDescPadding ? "descPadding" : null;
  return (
    <div
      className={`${styles.wrapper}  ${isWhiteBg ? "bg-white" : "bg-black"}`}
    >
      <div className="article-pages relative lg:flex lg:items-center lg:justify-center flex-col p-2 lg:p-0">
        <h3 className={`heading-model w-full text-${textPlacement}`}>
          {capitalizeFirstLetter(heading)}
        </h3>
        {description && (
          <p
            className={`description-model w-full text-center text-justify mt-7 mx-5 ${adjustDescPaddingClass}`}
          >
            {renderRichText(description, locale) || ""}
          </p>
        )}

        {upperBorder && (
          <hr className={`w-full hr-class  border-t-0 ${hrColorClass}`} />
        )}
        <div className="slider-wrapper pb-10">
          <Slider {...settings}>
            {images?.map(
              (item, i) =>
                item?.fields && (
                  <div key={i} className="slide-item">
                    {item.fields?.externalUrl ? (
                      <Link
                        target="_blank"
                        rel="noopener noreferrer"
                        href={item.fields?.externalUrl}
                        className={styles.imageLink}
                      >
                        <ImageSection item={item} />
                      </Link>
                    ) : (
                      <ImageSection item={item} />
                    )}
                  </div>
                )
            )}
          </Slider>
        </div>
        <hr className={`w-full hr-class  border-t-0 ${hrColorClass}`} />
      </div>
    </div>
  );
};

const ImageSection = imageParam => {
  const { item } = imageParam;
  return (
    <div className={styles.imageWrapper}>
      <Image
        src={item?.fields?.imageUrl || item?.fields?.asset?.fields?.file?.url}
        alt={item?.fields?.altText}
        width={0}
        height={100}
        className={`w-full imageClass`}
      />
      {item.fields.description && (
        <div className={styles.outerLayerCaption}>
          <div className={styles.carouselImageCaption}>
            <p className="capitalize text-white text-center text-[14px] leading-snug mb-[10px]">
              {item.fields.description}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

ArticlePageCarousel.propTypes = {
  fields: PropTypes.object.isRequired,
};

ArticlePageCarousel.defaultProps = {
  fields: {},
};

export default ArticlePageCarousel;
